import React from "react"
import { Container } from "reactstrap"
import LoginForm from "./LoginForm"

import { NavLink } from "react-router-dom"
import { Trans } from "@lingui/react"

export default function LoginPage() {
  return (
    <Container>
      <LoginForm />
      <Container style={{ textAlign: "center", color: "#6c757d" }}>
        <span style={loadingStyle}>
          <Trans id="dont have account" />
        </span>
        <NavLink to={{ pathname: `/SignUpPage` }}>
          {" "}
          <b>
            <u style={loadingStyle}>
              <Trans id="signup" />
            </u>
          </b>
        </NavLink>
        <br />
        <br />
        {window.REACT_APP_PWA_APP_ENV === "production" && (
          <NavLink to={{ pathname: "/phoneVerify" }}>
            <span
              style={{
                textAlign: "right",
                fontFamily: "Fira Sans",
                fontSize: "16px",
                color: "#6c757d",
                marginRight: "0.2em",
              }}
            >
              <u>
                <Trans id="forgot.pin" />
              </u>
            </span>
          </NavLink>
        )}
      </Container>
    </Container>
  )
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "18px",
}
